import React, { useEffect } from "react";
import BlobDefinitions from "./components/BlobDefinitions";
import ContactSection from "./components/ContactSection";
import GettingStartedSection from "./components/GettingStartedSection";
import HowItWorksSection from "./components/HowItWorksSection";
import MoneySection from "./components/MoneySection";
import TakingACourseSection from "./components/TakingACourseSection";
import TechSection from "./components/TechSection";
import AboutUsSection from "./components/AboutUsSection";
import TeamsSection from "./components/TeamsSection";
import Hero from "./components/Hero";
import TableOfContents from "./components/TableOfContents";

const Faq = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BlobDefinitions />

      <main id="faq" className="pages">
        <Hero />
        <TableOfContents />
        <GettingStartedSection />
        <HowItWorksSection />
        <MoneySection />
        <TakingACourseSection />
        <TechSection />
        <AboutUsSection />
        <TeamsSection />
      </main>
      <ContactSection />
    </>
  );
};

export default Faq;
